import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DocumentFile } from '@app/interfaces/dm/document';
import { Task, TaskConfigField, TaskFile } from '@app/interfaces/lm/kanban-board';
import { STChange, STColumn, STData, STScroll } from '@app/interfaces/sys/st';
import { DocumentService } from '@services/dm/document.service';
import { FileService } from '@services/lm/file.service';
import { KanbanBoardService } from '@services/lm/kanban-board.service';
import { ConfirmationService } from '@services/sys/confirmation.service';
import { SettingsService } from '@services/sys/settings.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import dayjs from 'dayjs';

@Component({
  selector: 'app-task-attachments',
  templateUrl: './task-attachments.component.html',
  styleUrl: './task-attachments.component.less'
})
export class TaskAttachmentsComponent  implements OnInit, OnChanges {
    @Input() field!: TaskConfigField | undefined;
    @Input() taskDetail: Task = {} as Task;
    @Input() templateAllFields: TaskConfigField[] = [];
    @Input() batchUpload = false;
    @Input() inactiveUsers: boolean = false;
    @Output() updateAttachment = new EventEmitter();
    @Output() uploadEvent = new EventEmitter();

    columns: STColumn[] = [
        {
            title: 'File Name',
            index: 'fileName',
            sort: true,
            width: '150px',
            sortFn: (a: STData, b: STData) => a.fileName.localeCompare(b.fileName),
        },
        {
            title: 'File Size',
            index: 'fileSize',
            format: (item: STData) => {
                return item.fileSize ? this.formatSize(item.fileSize) : '';
            },
            sort: true,
            width: '100px',
            sortFn: (a: STData, b: STData) => (a.fileSize || 0) - (b.fileSize || 0),
        },
        {
            title: 'Date Added',
            index: 'createdDate',
            type: 'date',
            dateFormat: 'YYYY-MM-dd HH:mm:ss',
            sort: true,
            width: '140px',
            sortFn: (a: STData, b: STData) => dayjs(a.createdDate).valueOf() - dayjs(b.createdDate).valueOf(),
        },
        {
            title: 'Actions',
            render: 'action',
            className: 'remove-padding',
            width: '100px',
        },
    ];
    page = 0;
    size = 10;
    total = 0;
    data: Array<TaskFile> = [];
    loading = false;
    params: {
        [key: string]: string
    } = {
        keyword: '',
    };
    nzScroll: STScroll = {};
    currentValue: string[] = [];

    constructor(private settingService: SettingsService,
                private documentService: DocumentService,
                private message: NzMessageService,
                private kanbanBoardService: KanbanBoardService,
                private modal: NzModalService,
                private fileService: FileService,
                private confirmationService: ConfirmationService) {
    }

    @HostListener('window:resize')
    _resize(): void {
        this.setScroll();
    }

    setScroll(): void {
        this.settingService.setLayout();
        const { y } = this.settingService.layout;
        this.nzScroll = {
            x: '500px',
            y: `${y}px`,
        };
    }

    ngOnInit(): void {
        this.setScroll();
    }

    ngOnChanges(changes: SimpleChanges): void {
        const { taskDetail, field } = changes;
        if (taskDetail || field) {
            this.getFileList();
        }
    }

    /* 获取固定的attachment的列表 */
    getFileList(): void {
       try {
           const { taskContentResponses } = this.taskDetail;
           if (!this.field) {
               this.data = [];
               return;
           }
           const valueItem = (taskContentResponses || []).find(it => it.taskConfigFieldId === (this.field as TaskConfigField).id);
           if (!valueItem) {
               this.data = [];
               return;
           }
           this.loading = true;
           const arr = valueItem.value as string[];
           this.currentValue = arr;
           this.data = (arr || []).map(it => {
               return JSON.parse(it);
           });
           console.log('刷新列表', this.currentValue);
       } finally {
           this.loading = false;
       }
    }

    handleChange(event: STChange): void {
        // const { type, pi, sort, ps } = event;
        // if (type === 'pi') {
        //     this.page = pi - 1;
        //     this.fetchData();
        // }
        // if (type === 'sort') {
        //     this.params = {
        //         ...this.params,
        //         sort,
        //     };
        //     this.handleRefresh();
        // }
        //
        // if (type === 'ps') {
        //     this.size = ps;
        //     this.handleRefresh();
        // }
    }

    handleRefresh(): void {
        this.page = 0;
    }

    refreshEmitter(): void {
        this.handleRefresh();
        // this.successRefresh.emit();
    }


    handleDownload(row: DocumentFile): void {
        this.documentService.download(row.fileId || row.id);
    }

    edit(row: DocumentFile): void {
        // this.editLink.emit(row);
    }

    formatSize(size: number): string {
        if (size > 1024 * 1024) {
            return (size / (1024 * 1024)).toFixed(1) + ' MB';
        } else if (size > 52) {
            return (size / 1024).toFixed(1) + ' KB';
        }
        return size + ' B';
    }

    handleRemove(row: DocumentFile, index: number): void {
        this.modal.confirm({
            nzTitle: `Delete this file?`,
            nzOkText: 'Yes',
            nzCancelText: 'No',
            nzOkType: 'primary',
            nzOkDanger: true,
            nzStyle: { top: '40vh' },
            nzOnOk: () => {
                this.confirmationService.confirmUpdateTask(this.inactiveUsers, async () => {
                    this.data.splice(index, 1);
                    const value = this.data.length > 0 ? this.data.map(it => JSON.stringify(it)) : [];
                    this.saveFieldValue(value);
                });
            },
        });
    }

    async saveFieldValue(value: string[]): Promise<void> {
        const { taskContentResponses } = this.taskDetail;
        const data = this.kanbanBoardService.getTaskFieldContents(this.field as TaskConfigField, value, this.templateAllFields, taskContentResponses);
        this.updateAttachment.emit({
            taskFieldContents: data
        });
    }

    async addFile(newFile: DocumentFile[]): Promise<void> {
        this.uploadEvent.emit(newFile);
    }

    downloadAll(): void {
        if (!this.data?.length) {
          return;
        }
        this.documentService.downloadAll(this.data.map(it => it.fileId));
    }
}

